import React from 'react'
import { Component } from 'react';
import authService from './AuthorizeService';
import { AuthenticationResultStatus } from './AuthorizeService';
import { ApplicationPaths, QueryParameterNames, LogoutActions } from './ApiAuthorizationConstants';

// The main responsibility of this component is to handle the user's logout process.
// This is the starting point for the logout process, which is usually initiated when a
// user clicks on the logout button on the LoginMenu component.
export class Logout extends Component {
	constructor(props) {
		super(props);

		this.state = {
			message: undefined,
			isReady: false,
			authenticated: false
		};
	}

	redirectToLogin = () => {
		const loginPath = `${ApplicationPaths.Login}`;
		const redirectUrl = `${window.location.origin}${loginPath}`;

		window.location.replace(redirectUrl);
	};

	componentDidMount() {
		const action = this.props.action;

		switch (action) {
			case LogoutActions.Logout:
				if (window.history.state && !!window.history.state.state.local) {
					this.logout(this.getReturnUrl());
				} else {
					this.redirectToLogin();
				}

				break;

			case LogoutActions.LogoutCallback:
				break;

			case LogoutActions.LoggedOut:
				this.setState(this.getReturnUrl());
				break;

			default:
				throw new Error(`Invalid action '${action}'`);
		}

		this.populateAuthenticationState();
	}

	render() {
		const { isReady, message } = this.state;

		if (!isReady) {
			return <div></div>
		}

		if (!!message) {
			return (<div>{message}</div>);
		} else {
			const action = this.props.action;

			switch (action) {
				case LogoutActions.Logout:
					return null;

				case LogoutActions.LogoutCallback:
					return null;

				case LogoutActions.LoggedOut:
					return (<div>{message}</div>);

				default:
					throw new Error(`Invalid action '${action}'`);
			}
		}
	}

	async logout(returnUrl) {
		const state = { returnUrl };
		const isAuthenticated = await authService.isAuthenticated();

		if (isAuthenticated) {
			const result = await authService.signOut(state);

			switch (result.status) {
				case AuthenticationResultStatus.Redirect:
					break;

				case AuthenticationResultStatus.Success:
					this.navigateToReturnUrl(returnUrl);
					break;

				case AuthenticationResultStatus.Fail:
					this.setState({ message: result.message });
					break;

				default:
					throw new Error("Invalid authentication result status.");
			}
		} else {
			this.setState(this.getReturnUrl());
		}
	}

	modifyUrl(state) {
		if (!state) return state;

		let url = state.split('/');

		if (url.length === 1 && url[1] === '')
			return state + "/";
		else
			return state;
	}

	async populateAuthenticationState() {
		const authenticated = await authService.isAuthenticated();
		this.setState({ isReady: true, authenticated });
	}

	getReturnUrl(state) {
		const params = new URLSearchParams(window.location.search);
		const fromQuery = params.get(QueryParameterNames.ReturnUrl);

		if (fromQuery && !fromQuery.startsWith(`${window.location.origin}/`))
			// This is an extra check to prevent open redirects.
			throw new Error("Invalid return url. The return url needs to have the same origin as the current page.")

		return (state && state.returnUrl) || fromQuery || `${window.location.origin}/`;
	}

	navigateToReturnUrl(returnUrl) {
		return window.location.replace(returnUrl);
	}
}
